import { Box, Card, CardBody, Heading, Stack, StackDivider, Text } from '@chakra-ui/react'
import React from 'react'

const CardView = ({ cardObj }) => {
    return (
        <>
            <Card>
                <CardBody>
                    <Stack divider={<StackDivider />} spacing='4'>
                        {
                            Object.keys(cardObj).map(item =>
                                <Box key={item}>
                                    <Text fontSize='sm' color="gray.500">
                                        {item}
                                    </Text>
                                    <Text pt='2' fontSize='sm'>
                                        {cardObj[item] ? cardObj[item] : '-'}
                                    </Text>
                                </Box>
                            )
                        }
                    </Stack>
                </CardBody>
            </Card>
            <br />
        </>
    )
}

export default CardView